import AllosIcon from './logo/allos-icon.png';
import styles from './SidebarLogo.module.css';

export const LogoIcon = () => (
  <img className={styles.logoIcon} src={AllosIcon} alt="ALLOS" />
);
